import {gql} from "@apollo/client";
import {VoucherClearingFilterType,VoucherClearingType} from "../types/VoucherClearingType";

export const FIELDS = `
    id
    settlementClientId
    settlementClientName
    settlementItemCode
    settlementItemName
    businessId
    otherBusinessId
    status
    amount
    amountHm
    currency
    businessTime
    settlementTime
    timeZone
`;

export const GET_VOUCHER_CLEARING_LISTING = gql`
    query VoucherClearingQuery($filters: VoucherClearingFilterTypeInput,
                       $pageRequest: PageRequestTypeInput) {
        getVoucherClearingPageable(filters: $filters, pageRequest: $pageRequest) {
            content{
                ${FIELDS}
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

export interface VoucherClearingListResponse {
    getVoucherClearingPageable: VoucherClearingResponseType;
}

export interface VoucherClearingResponseType {
    content: VoucherClearingType[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

interface VoucherClearingTypeInput {
    filters?: VoucherClearingFilterType;
    pageRequest?: PageRequestType;
}

interface PageRequestType {
    page: number;
    size: number;
    sortBy: string;
    sortDirection: string;
}

